import type {
  AdminDemoResetBatchResponse,
  AdminDemoResetCapability,
  AdminDemoResetCapabilityState,
} from "../../../../api/kehrblatt/admin-demo-resets"

export const adminDemoResetCapabilityReason = (
  capability: AdminDemoResetCapability | null | undefined,
): string => {
  if (!capability) return "Reset-Verfügbarkeit konnte nicht geladen werden."

  const reasons: Record<AdminDemoResetCapabilityState, string> = {
    ready: "Demo-Daten dieser Organisation zurücksetzen.",
    not_found: "Organisation wurde nicht gefunden.",
    inactive: "Nur aktive Organisationen können zurückgesetzt werden.",
    admin_organization: "Plattform-Organisationen können nicht zurückgesetzt werden.",
    not_free_trial: "Nur Free-Trial-Organisationen können zurückgesetzt werden.",
    checkout_required: "Organisationen mit Checkoutpflicht können nicht zurückgesetzt werden.",
    never_successfully_reset: "Noch kein erfolgreicher Demo-Reset vorhanden.",
    missing_admin_credentials: "Aktuelle Zugangsdaten des Organisationsadmins fehlen.",
    missing_employee_credentials: "Aktuelle Zugangsdaten eines Mitarbeiters fehlen.",
    active_job: "Für diese Organisation läuft bereits ein Demo-Reset.",
  }

  return reasons[capability.state]
}

export const summarizeAdminDemoResetBatch = (response: AdminDemoResetBatchResponse): string => {
  const queued = response.results.filter(
    (item) => item.disposition === "queued" || item.disposition === "idempotent_replay",
  ).length
  const active = response.results.filter((item) => item.disposition === "already_active").length
  const rejected = response.results.filter((item) => item.disposition === "rejected").length

  return [
    queued ? `${queued} eingereiht` : null,
    active ? `${active} bereits laufend` : null,
    rejected ? `${rejected} abgelehnt` : null,
  ]
    .filter(Boolean)
    .join(", ")
}
